// extracted by mini-css-extract-plugin
export default {"container":"App-container___eUoEN"};